<!--
 * @Author: huchunlei 1571641457@qq.com
 * @Date: 2023-01-06 09:57:35
 * @LastEditors: huchunlei 1571641457@qq.com
 * @LastEditTime: 2024-06-22 09:34:42
 * @FilePath: \ticket3\src\App.vue
 * @Description: 
 * 
 * Copyright (c) 2024 by 北京森泰英睿传媒科技有限公司. 
-->
<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
    <router-view />
  </div>
</template>

<script>
  export default {
    name: 'App'
  }

</script>

<style>
  * {
    margin: 0;
    padding: 0;
  }

  .el-table__body {
    width: 100% !important;
    table-layout: auto !important;
  }

  html,
  body,
  #app {
    height: 100%;
    width: 100%;
    margin: 0;
    padding: 0;
    min-width: 1366px;
  }

  /* #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
} */
  .el-table__body-wrapper {
    /* overflow: auto !important; */
  }

</style>
<style>
  .el-button.is-circle {
    border-radius: 10% !important;
  }

  /* body .el-table th.gutter{
  display: table-cell!important;
} */
  .el-button.is-round {
    border-radius: 6px !important;
  }

  .el-table {
    position: static !important;
  }


  .el-table {
    width: 100%;

  }

  .el-table__header-wrapper table,
  .el-table__body-wrapper table {
    width: 100% !important;
  }

  .el-table__body,
  .el-table__footer,
  .el-table__header {
    table-layout: auto;
  }

</style>



// WEBPACK FOOTER //
// src/App.vue